export default __webpack_public_path__ + "media/zurb/img/playground/ux-metric-play-hero-e3411221bfba28e21d9f455abd0b72f2.png";